import netConfig from "@/views/netConfig/netConfig";
export default netConfig;
